<template>
  <div class="page">
    <div class="page-content">
      <v-card class="card-content" dark>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="filter.idfornecedor"
              outlined
              dense
              label="Fornecedor"
              :items="listFornecedor"
              :search-input.sync="searchFornecedor"
              hide-no-data
              hide-selected
              item-text="nome"
              dark
              clearable
              item-value="idfornecedor"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-menu
              ref="menuInitialPicker"
              v-model="filter.menuInitialPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateInitFormatted"
                  label="Data inicial"
                  readonly
                  dark
                  outlined
                  dense
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filter.dataInicial" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="filter.menuInitialPicker = false"
                  >Fechar</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menuInitialPicker.save(filter.dataInicial)"
                  >Confirmar</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu
              ref="menuFinalPicker"
              v-model="filter.menuFinalPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFinalFormatted"
                  label="Data final"
                  readonly
                  dark
                  outlined
                  dense
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filter.dataFinal" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="filter.menuFinalPicker = false"
                  >Fechar</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menuFinalPicker.save(filter.dataFinal)"
                  >Confirmar</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="filter.tagEvent"
              outlined
              dense
              dark
              label="Evento"
              :items="filterTagEvent"
              hide-no-data
              hide-selected
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="filter.idusuario"
              label="Id usuário"
              dark
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="filter.search"
              label="Busca textual"
              dark
              outlined
              dense
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="filter.entity"
              outlined
              dense
              label="Entidade"
              :items="listIndexes"
              hide-no-data
              hide-selected
              dark
              clearable
              @change="loadIndexFilter"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <template v-if="showAdvanced">
          Filtros avançados
          <template v-for="item in filter.indexFilter">
            <v-divider dark :key="item.id + 'line'"></v-divider>
            <v-row :key="item.id" align="center">
              <v-col cols="5">
                <v-autocomplete
                  v-model="item.filter"
                  outlined
                  dense
                  label="Filtro"
                  :items="filterIndex"
                  hide-no-data
                  hide-selected
                  dark
                  return-object
                  item-text="key"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="item.value"
                  label="Valor"
                  dark
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-btn icon dark small @click="removeIndexFilter(item.id)"
                  ><v-icon size="15">fas fa-times</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </template>
          <v-row align="center" justify="center">
            <v-col cols="1" @click="addIndexFilter">
              <v-btn icon dark small
                ><v-icon size="15">fas fa-plus</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </template>
        <v-row justify="end">
          <v-col cols="2">
            <v-btn
              color="secondary"
              rounded
              large
              dark
              @click="showAdvanced = !showAdvanced"
              >{{ showAdvanced ? 'Filtro simples' : 'Filtro avançado' }}</v-btn
            >
          </v-col>
          <v-col cols="2">
            <v-btn color="success" rounded large dark @click="loadData"
              >Buscar</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="rows"
        :hide-default-footer="true"
        class="elevation-1 table-logs"
        no-data-text="Nenhum registro encontrado"
        no-results-text="Nenhum registro encontrado"
        :options="tableOptions"
        dark
        :loading="loading"
        loading-text="Carregando dados..."
        @click:row="onClick"
        @update:sort-by="onSortBy"
        @update:sort-desc="onSortDesc"
      >
        <template v-slot:item.data="{ item }">
          {{ item.data | formatDateTime }}
        </template>
        <template v-slot:item.instant="{ item }">
          <span
            class="instant"
            v-for="(instant, index) in item.instant"
            :key="'instant-' + instant + index + item.logsessionid"
            >{{ instant }}</span
          >
        </template>
        <template
          v-slot:footer="{
            on,
            props: { pagination: { pageStart, pageStop } },
          }"
        >
          <div class="custom-footer">
            <div class="perpage-selector">
              <span>Itens por página:</span>
              <v-menu offset-y v-model="selectorPageOpen">
                <template v-slot:activator="{ on }">
                  <v-btn text v-on="on" :class="{ open: selectorPageOpen }">
                    <span style="margin-right:10px;">{{
                      options.itemsPerPage
                    }}</span>
                    <v-icon class="icon-selector">fas fa-caret-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="n in [5, 10, 15, 20, 30]"
                    :key="n"
                    @click="selectPerPage(n)"
                  >
                    {{ n }}
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="paga-index">
              Exibindo {{ calculePageStart(pageStart) }} a
              {{ pageStop + (options.start - 1 || 0) }} de
              {{ options.itemsLength }} registros
            </div>
            <div class="pagination-controll">
              <v-btn text :disabled="options.page <= 0" @click="prevPage"
                ><v-icon size="24">fas fa-chevron-left</v-icon></v-btn
              >
              <v-btn
                text
                :disabled="
                  options.itemsLength <= 0 ||
                    pageStop + options.start - 1 >= options.itemsLength
                "
                @click="
                  nextPage(options.itemsLength, pageStop + options.start - 1)
                "
                ><v-icon size="24">fas fa-chevron-right</v-icon></v-btn
              >
            </div>
          </div>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snackbar.open"
        :color="snackbar.color"
        left
        :timeout="1000"
      >
        {{ snackbar.message }}
      </v-snackbar>
    </div>
    <transition name="slide-popup" mode="out-in">
      <router-view class="subview"></router-view>
    </transition>
  </div>
</template>

<script>
import { LogAudit, LogControl } from '../service/Api'
import * as _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'LogAudit',
  data: () => ({
    options: {
      sortBy: ['data'],
      sortDesc: [true],
      itemsPerPage: 20,
      page: 0,
      showSelect: false,
      start: 1,
      itemsLength: 0,
    },
    selectorPageOpen: false,
    rows: [],
    loading: false,
    searchFornecedor: '',
    snackbar: {
      open: false,
      message: '',
      color: 'info',
    },
    headers: [
      {
        text: 'Log id',
        value: 'logsessionid',
      },
      {
        text: 'Data',
        value: 'data',
      },
      {
        text: 'Evento',
        value: 'tagEventDescription',
      },
      {
        text: 'Momento',
        value: 'instant',
      },
      {
        text: 'Entidade',
        value: 'entidades',
      },
    ],
    filter: {
      dataFinal: '',
      dataInicial: '',
      menuInitialPicker: false,
      menuFinalPicker: false,
      idfornecedor: '',
      tagEvent: '',
      idusuario: '',
      search: '',
      entity: '',
      indexFilter: [],
    },
    filterTagEvent: [],
    listFornecedor: [],
    onSearchDebounced: () => '',
    listIndexes: [],
    filterIndex: [],
    showAdvanced: false,
  }),
  watch: {
    searchFornecedor: {
      handler() {
        this.onSearchDebounced()
      },
    },
  },
  filters: {
    formatDateTime(value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
  },
  computed: {
    tableOptions() {
      return {
        ...this.options,
        page: 0,
      }
    },
    dateInitFormatted() {
      const parsedDate = moment(this.filter.dataInicial)
      if (parsedDate.isValid()) {
        return parsedDate.format('DD/MM/YYYY')
      }
      return this.filter.dataInicial
    },
    dateFinalFormatted() {
      const parsedDate = moment(this.filter.dataFinal)
      if (parsedDate.isValid()) {
        return parsedDate.format('DD/MM/YYYY')
      }
      return this.filter.dataFinal
    },
  },
  created() {
    this.onSearchDebounced = _.debounce(this.onSearch, 500)
  },
  mounted() {
    this.loadTagEvent()
    this.loadIndexes()
  },
  methods: {
    loadIndexes() {
      LogControl.indexes()
        .then(data => {
          const list = _.get(data, 'data', []).map(item => ({
            text: item.index,
            value: item.index,
          }))
          this.listIndexes = [
            {
              text: 'Todos',
              value: '',
            },
            ...list,
          ]
        })
        .catch(err => {
          console.log(err)
          this.listIndexes = [
            {
              text: 'Todos',
              value: '',
            },
          ]
          this.snackbar = {
            open: true,
            color: 'error',
            message: 'Falha ao buscar entidades',
          }
        })
    },
    loadTagEvent() {
      LogAudit.tagEvents()
        .then(data => {
          this.filterTagEvent = [
            {
              text: 'Todos',
              value: '',
            },
            ..._.get(data, 'data', []),
          ]
        })
        .catch(err => {
          console.log(err)
          this.snackbar = {
            open: true,
            color: 'error',
            message: 'Falha ao buscar tipos de eventos',
          }
        })
    },
    loadIndexFilter() {
      if (this.filter.entity) {
        LogAudit.indexFilters(this.filter.entity)
          .then(resp => {
            this.filterIndex = _.get(resp, 'data', [])
            this.filter.indexFilter = []
          })
          .catch(err => {
            this.snackbar = {
              open: true,
              color: 'error',
              message: 'Falha ao buscar filtros avançados',
            }
          })
      }
    },
    prevPage() {
      if (this.options.page > 0) {
        const newPage = this.options.page - 1
        this.options = {
          ...this.options,
          page: newPage,
          start: (newPage * 1 || 0) * this.options.itemsPerPage + 1,
        }
        this.loadData()
      }
    },
    nextPage(itemsLength, pageStop) {
      if (itemsLength > 0 && pageStop < itemsLength) {
        const newPage = this.options.page + 1
        this.options = {
          ...this.options,
          page: newPage,
          start: (newPage * 1 || 0) * this.options.itemsPerPage + 1,
        }
        this.loadData()
      }
    },
    selectPerPage(itemsPerPage) {
      this.options = {
        ...this.options,
        itemsPerPage,
        page: 0,
        start: 1,
      }
      this.loadData()
    },
    onSortBy(sortBy) {
      if (sortBy && sortBy.length > 0) {
        this.options.sortBy = sortBy
        this.loadData()
      }
    },
    onSortDesc(sortDesc) {
      if (sortDesc && sortDesc.length > 0) {
        this.options.sortDesc = sortDesc
        this.loadData()
      } else {
        this.options.sortDesc = []
      }
    },
    loadData() {
      if (
        !this.filter.dataInicial &&
        !this.filter.dataFinal &&
        !this.filter.tagEvent &&
        !this.filter.idfornecedor &&
        !this.filter.idusuario &&
        !this.filter.entity
      ) {
        this.snackbar = {
          open: true,
          color: 'error',
          message: 'Necessário informar ao menos um filtro de busca',
        }
        return
      }
      this.loading = true
      LogAudit.datatable({
        dataInicial: this.filter.dataInicial,
        dataFinal: this.filter.dataFinal,
        eventTag: this.filter.tagEvent,
        idfornecedor: this.filter.idfornecedor,
        idusuario: this.filter.idusuario,
        search: this.filter.search,
        page: this.options.page,
        perpage: this.options.itemsPerPage,
        entity: this.filter.entity,
        order: {
          column: _.get(this.options, 'sortBy.0', 'data'),
          direction: _.get(this.options, 'sortDesc.0', false) ? 'desc' : 'asc',
        },
        indexFilter: this.showAdvanced
          ? this.filter.indexFilter.map(item => ({
              key: _.get(item, 'filter.key', ''),
              type: _.get(item, 'filter.type', ''),
              value: _.get(item, 'value', ''),
            }))
          : [],
      })
        .then(data => {
          this.loading = false
          this.rows = _.get(data, 'data.rows', [])
          this.options.itemsLength = _.get(data, 'data.total', 0)
        })
        .catch(err => {
          this.loading = false
          this.snackbar = {
            open: true,
            color: 'error',
            message: 'Falha ao buscar logs de auditoria',
          }
        })
    },
    calculePageStart(pageStart) {
      if (this.options.itemsLength > 0) {
        return this.options.start + pageStart
      }
      return pageStart
    },
    async onSearch() {
      try {
        const cl1Response = await axios.get(
          `https://superon.lifeapps.com.br/api/v1/fornecedores/s2?filter=${this.searchFornecedor}`
        )
        const cl2Response = await axios.get(
          `https://admin-ecommerce-02.lifeappsecommerce.com.br/api/v1/fornecedores/s2?filter=${this.searchFornecedor}`,
        )
        const cl3Response = await axios.get(
          `https://admin-ecommerce.lifeappsecommerce.com.br/api/v1/fornecedores/s2?filter=${this.searchFornecedor}`,
        )

        this.listFornecedor = _.unionBy(
          [
            ..._.get(cl1Response, 'data', []),
            ..._.get(cl2Response, 'data', []),
            ..._.get(cl3Response, 'data', []),
          ],
          'idfornecedor'
        )
      } catch (err) {
        this.snackbar = {
          open: true,
          color: 'error',
          message: 'Falha ao pesquisar fornecedores',
        }
      }
    },
    onClick(row) {
      console.log(row)
      this.$router.push('/audit/' + row.logsessionid)
    },
    addIndexFilter() {
      this.filter.indexFilter.push({
        id: uuidv4(),
        filter: null,
        value: null,
      })
    },
    removeIndexFilter(id) {
      this.filter.indexFilter = this.filter.indexFilter.filter(
        item => item.id !== id
      )
    },
  },
}
</script>

<style lang="scss">
.custom-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: 10px 20px;
  .paga-index {
    padding: 0 15px;
  }
  .perpage-selector {
    min-width: 50px;
    display: flex;
    align-items: center;
    flex: 0 0 0;
    justify-content: flex-end;
    white-space: nowrap;
    .icon-selector {
      transition: all 0.3s ease-in-out;
    }
    .open {
      .icon-selector {
        transform: rotate(180deg);
      }
    }
  }
  .pagination-controll {
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      width: 50px;
      padding: 5px;
      min-width: initial;
      height: initial;
    }
    button:last-child {
      margin-left: 5px;
    }
  }
}
@media (max-width: 768px) {
  .custom-footer {
    flex-direction: column;
    .paga-index,
    .pagination-controll {
      padding: 7px 15px;
    }
  }
}
.instant {
  padding: 2.5px;
  margin: 2px;
  background-color: #ccc;
  border-radius: 5px;
  color: #000;
  font-size: 12px;
}
.table-logs {
  margin-top: 15px;
}
.subview {
  position: absolute;
  top: 50px;
  right: 0;
  min-height: 100%;
}
</style>
